import { Box, Input as CInput, Flex, Icon, Text } from '@chakra-ui/react'
import { AiOutlineCheck } from 'react-icons/ai'
import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { ErrorMessage } from './error-message'

type Default = {
  isValid?: boolean | string
  isError?: string
  label: string
  id: string
  type?: 'password' | 'email' | 'text' | 'date' | 'number'
  inputMode?:
    | 'email'
    | 'text'
    | 'search'
    | 'none'
    | 'tel'
    | 'url'
    | 'numeric'
    | 'decimal'
    | undefined
  info?: string
  flex?: number
}

interface Props extends Default {
  formHook: UseFormRegisterReturn
  value?: string
}

export const Input = ({
  id,
  label,
  isValid,
  flex,
  isError,
  type = 'text',
  formHook,
  value,
  info,
  inputMode = 'text'
}: Props) => {
  return (
    <Box flex={flex} mb="2rem">
      <Box w="100%" pos="relative">
        <CInput
          sx={{
            '&:focus + label': {
              top: 0,
              color: '#4D80E4'
            }
          }}
          id={id}
          w="100%"
          type={type}
          h="4.5rem"
          paddingInline="1.6rem"
          fontSize="1.4rem"
          inputMode={inputMode}
          autoComplete="off"
          pos="relative"
          borderColor={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : '#DDDDDD'}
          borderRadius="1rem"
          _focus={{ border: '1px solid #4D80E4' }}
          {...formHook}
        />
        <Text
          as="label"
          htmlFor={id}
          pos="absolute"
          top={value ? 0 : '50%'}
          left="1.5rem"
          transform="translateY(-50%)"
          bg="#fff"
          color={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : ''}
          pointerEvents="none"
          transition="all 0.3s"
          fontSize="1.25rem"
          px="5px">
          {label}
        </Text>
        <Flex
          justify="center"
          align="center"
          right="1.5rem"
          top="0"
          w="auto"
          h="100%"
          pos="absolute">
          {isValid && <Icon w={8} h={10} color="brand.successBlue" as={AiOutlineCheck} />}
        </Flex>
      </Box>
      {info && !isError && (
        <Text mt="0.7rem" fontSize="1rem">
          {' '}
          {info}
        </Text>
      )}
      <ErrorMessage isError={isError} />
    </Box>
  )
}

interface ControlProps extends Default {
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const ControlledInput = ({
  id,
  label,
  isValid,
  isError,
  type = 'text',
  value,
  inputMode = 'text',
  onChange,
  info,
  flex
}: ControlProps) => {
  return (
    <Box flex={flex} mb="2rem">
      <Box w="100%" pos="relative">
        <CInput
          sx={{
            '&:focus + label': {
              top: 0,
              color: '#4D80E4'
            }
          }}
          id={id}
          w="100%"
          type={type}
          h="4.5rem"
          paddingInline="1.6rem"
          fontSize="1.4rem"
          pos="relative"
          inputMode={inputMode}
          onChange={onChange}
          value={value}
          borderColor={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : '#DDDDDD'}
          borderRadius="1rem"
          _focus={{ border: '1px solid #4D80E4' }}
        />
        <Text
          as="label"
          htmlFor={id}
          pos="absolute"
          top={value ? 0 : '50%'}
          left="1.5rem"
          transform="translateY(-50%)"
          bg="#fff"
          color={isError ? 'brand.red' : isValid === true ? 'brand.successBlue' : ''}
          pointerEvents="none"
          transition="all 0.3s"
          fontSize="1.25rem"
          px="5px">
          {label}
        </Text>
        <Flex
          justify="center"
          align="center"
          right="1.5rem"
          top="0"
          w="auto"
          h="100%"
          pos="absolute">
          {isValid && <Icon w={8} h={10} color="brand.successBlue" as={AiOutlineCheck} />}
        </Flex>
      </Box>
      {info && !isError && (
        <Text mt="0.7rem" fontSize="1rem">
          {info}
        </Text>
      )}
      <ErrorMessage isError={isError} />
    </Box>
  )
}
